import React from "react";
import ResearchPapers from "./ResearchPapers";
import BookPublications from "./BookPublications";
import BookChapters from "./BookChapters";
import ConfrencePapers from "./ConferencePapers";

const AcademicActivites = ({ register, control, errors, disabled }) => {
  return (
    <>
      <ResearchPapers
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
      <BookPublications
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
      <BookChapters
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
      <ConfrencePapers
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
    </>
  );
};

export default AcademicActivites;
